import { Add, Delete, Edit, Input } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { createAxios } from "../../common/axios";
import { useDialog, useListItemDeleteApi, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { InputSizedButtonSx } from "../../common/form";
import { ListStoreDropDown } from "../../common/listStoreUi";
import { ProjectDto, createStores } from "./common";
import { ProjectDialog } from "./ProjectDialog";
import { sortBy } from "lodash";
import { useState } from "react";

export function Project({ stores: {
    selectedProduct, isFetchingProducts,
    selectedProject, isFetchingProjects,
    useProjectListStore,
    useSaleArticleListStore,
    useProjectSaleArticleListStore,
    useProjectCycleListStore, useProjectCycleDetailListStore, useCreditLimitListStore,
    useDiscountListStore, useDunningLevelListStore, useProjectOfferListStore, useProjectStartListStore,
} }: {
    stores: ReturnType<typeof createStores>;
}) {
    const [copyFromProject, setCopyFromProject] = useState<ProjectDto>();
    const editProjectDialog = useDialog(close => <ProjectDialog close={close} project={selectedProject} useSaleArticleListStore={useSaleArticleListStore}
        useProjectSaleArticleListStore={useProjectSaleArticleListStore} setCopyFromProject={p => {
            setCopyFromProject(p);
            newProjectDialog.show();
        }}
        projectChanged={projectChanged} useProjectListStore={useProjectListStore} product={selectedProduct!} />, "sm");
    const newProjectDialog = useDialog(close => <ProjectDialog close={close} project={null} useSaleArticleListStore={useSaleArticleListStore}
        useProjectSaleArticleListStore={useProjectSaleArticleListStore} copyFromProject={copyFromProject}
        projectChanged={projectChanged} useProjectListStore={useProjectListStore} product={selectedProduct!} />, "sm");

    const simpleDialog = useSimpleDialog();

    function projectChanged(project: ProjectDto) {
        let items = useProjectListStore.getState().items;
        if (items.some(p => p.id === project.id)) {
            items = items.map(p => p.id === project.id ? project : p);
        } else {
            items = items.concat(project);
        }
        sortBy(items, p => p.code);
        useProjectListStore.getState().setItems(items, false);
        useProjectListStore.getState().setSelectedItem(project);
        useProjectListStore.getState().setSelectedItem(project);
    }

    const itemDelete = useListItemDeleteApi(useProjectListStore, p => `products/projects/${p.id}`, "project", simpleDialog);
    async function importProject() {
        simpleDialog.show("Project", "Import default values for selected project?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().post(`products/projects/${selectedProject!.id}/import`);
            } finally {
                useProjectListStore.getState().fetch();
                useProjectCycleListStore.getState().fetch();
                useProjectCycleDetailListStore.getState().fetch();
                useCreditLimitListStore.getState().fetch();
                useDiscountListStore.getState().fetch();
                useDunningLevelListStore.getState().fetch();
                useProjectOfferListStore.getState().fetch();
                useProjectStartListStore.getState().fetch();
            }
        }));
    }

    const isFetching = isFetchingProducts || isFetchingProjects;

    return <>
        {simpleDialog.render()}
        {editProjectDialog.render()}
        {newProjectDialog.render()}
        <Grid item xs><ListStoreDropDown label="Project" useStore={useProjectListStore} getItemId={p => p.id} getItemName={p => p.code + " " + p.name} /></Grid>
        <Grid item><Button title="Edit" disabled={selectedProject == null || isFetching} onClick={() => editProjectDialog.show()} sx={InputSizedButtonSx} color="edit"><Edit /></Button></Grid>
        <Grid item><Button title="Add" disabled={selectedProduct == null || isFetching} onClick={() => newProjectDialog.show()} sx={InputSizedButtonSx} color="add"><Add /></Button></Grid>
        <Grid item><Button title="Delete" disabled={selectedProject == null || isFetching} onClick={itemDelete.showDialog} sx={InputSizedButtonSx} color="delete"><Delete /></Button></Grid>
        <Grid item><Button title="Import default values" disabled={selectedProject == null || isFetching} onClick={importProject} sx={InputSizedButtonSx}><Input /></Button></Grid>
    </>;
}